import { ButtonHTMLAttributes, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { Loader2, type LucideIcon } from 'lucide-react'

export type VarianteBoton = 'contained' | 'outlined' | 'text'
export type ColorBoton = 'primary' | 'secondary' | 'success' | 'error' | 'white'
export type TamBoton = 'sm' | 'md' | 'lg'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variante?: VarianteBoton
  color?: ColorBoton
  tam?: TamBoton
  /** Ícono antes de la etiqueta. El tamaño lo pone el botón (16px). */
  icono?: LucideIcon
  /** Ícono después de la etiqueta. */
  iconoFinal?: LucideIcon
  /** Deshabilita y cambia el ícono por un spinner mientras dura una petición. */
  cargando?: boolean
  /** Ruta interna del SPA: renderiza un <Link> con forma de botón. */
  to?: string
  /** URL externa o del backend: renderiza un <a>. */
  href?: string
  children?: ReactNode
}

export function clasesBoton(variante: VarianteBoton = 'contained', color: ColorBoton = 'primary', tam: TamBoton = 'md') {
  return `dcc-btn dcc-btn--${tam} dcc-btn--${variante} dcc-btn--${color}`
}

/**
 * Botón del kit: variante × color × tamaño (kit 2.6.0). Por defecto relleno y primario.
 * Con `to` o `href` se vuelve un enlace con la misma forma.
 */
export function Boton({
  variante, color, tam, icono: Icono, iconoFinal: IconoFinal, cargando, to, href, className, children, disabled, type = 'button', ...resto
}: Props) {
  const clases = `${clasesBoton(variante, color, tam)}${className ? ` ${className}` : ''}`
  const contenido = (
    <>
      {cargando ? <Loader2 className="dcc-icon dcc-i girando" aria-hidden /> : Icono && <Icono className="dcc-icon dcc-i" aria-hidden />}
      {children}
      {IconoFinal && <IconoFinal className="dcc-icon dcc-i" aria-hidden />}
    </>
  )
  if (to) return <Link to={to} className={clases}>{contenido}</Link>
  if (href) return <a href={href} className={clases}>{contenido}</a>
  return (
    <button type={type} className={clases} disabled={disabled || cargando} aria-busy={cargando || undefined} {...resto}>
      {contenido}
    </button>
  )
}
